module.exports = __webpack_public_path__ + "static/media/statewide_icon.caf3eb63.png";